import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "doubleArrowLeft" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M11 19L4 12L11 5M19 19L12 12L19 5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }